import Vue from 'vue';

export class EventBus extends Vue {

}
